import { render, staticRenderFns } from "./RecordModal.vue?vue&type=template&id=51171324&scoped=true"
import script from "./RecordModal.vue?vue&type=script&lang=js"
export * from "./RecordModal.vue?vue&type=script&lang=js"
import style0 from "./RecordModal.vue?vue&type=style&index=0&id=51171324&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51171324",
  null
  
)

export default component.exports